var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMostListenedDecor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#0061FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 14.4992C35.4999 14.2773 35.4567 14.0583 35.3736 13.8578C35.2905 13.6573 35.1695 13.4804 35.0194 13.3398C34.8692 13.1992 34.6937 13.0984 34.5053 13.0446C34.317 12.9909 34.1206 12.9856 33.9303 13.0291L20.8052 16.0292C20.5078 16.0972 20.2402 16.2807 20.0478 16.5487C19.8554 16.8167 19.7502 17.1526 19.75 17.4993V31.1708C19.3197 31.0562 18.8793 30.9988 18.4375 30.9998C16.2627 30.9998 14.5 32.3423 14.5 33.9999C14.5 35.6574 16.2627 37 18.4375 37C20.6123 37 22.375 35.6574 22.375 33.9999V21.7294L32.875 19.3293V28.1707C32.4447 28.0561 32.0043 27.9987 31.5625 27.9997C29.3877 27.9997 27.625 29.3422 27.625 30.9998C27.625 32.6573 29.3877 33.9999 31.5625 33.9999C33.7373 33.9999 35.5 32.6573 35.5 30.9998V14.4992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMostListenedDecor);
export default __webpack_public_path__ + "static/media/most-listened-decor.246d999b802b326097655d26510aaf44.svg";
export { ForwardRef as ReactComponent };